// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { getType } from 'typesafe-actions';
import { ProductCard } from '../../components/NewCard/types';
import { PaginationListResponse } from '../../types/Model';
import { KeywordTitle } from '../actionCreators/search/searchExamsKeywordActions';

import { RootAction, actionCreatorsList } from '../rootActionCreator';

export interface SearchExamsState {
  examsListData: PaginationListResponse<ProductCard>;
  examsKeyword: { [key: string]: KeywordTitle[] };
  isFetching: boolean;
  isFetchingMore: boolean;
  isKeywordFetching: boolean;
  error?: Error;
  keywordError?: Error;
}

const {
  searchExamsActions,
  searchExamsKeywordActions
} = actionCreatorsList;

export const initialSearchExamsState: SearchExamsState = {
  examsListData: {
    list: [],
    totalPage: 0,
    count: 0,
    page: 0,
    limit: 0,
  },
  examsKeyword: {},
  isFetching: true,
  isFetchingMore: false,
  isKeywordFetching: true
};

export default function (state = initialSearchExamsState, action: RootAction): SearchExamsState {
  switch (action.type) {
    /** searchExamsActions will trigger when new condition is given */
    case getType(searchExamsActions.request): {
      return {
        ...state,
        isFetching: true,
        isFetchingMore: action.payload.page > 1,
        error: undefined,
      };
    }
    case getType(searchExamsActions.success): {
      const {
        list,
        totalPage,
        count,
        page,
        limit,
      } = action.payload;

      const nextList = page === 1 ? list : [...state.examsListData.list, ...list];
      return {
        ...state,
        isFetching: false,
        isFetchingMore: false,
        examsListData: {
          list: nextList,
          totalPage,
          count,
          page,
          limit,
        },
      };
    }
    case getType(searchExamsActions.failure): {
      return {
        ...state,
        isFetching: false,
        isFetchingMore: false,
        error: action.payload.error
      };
    }
    case getType(searchExamsKeywordActions.request): {
      return {
        ...state,
        isKeywordFetching: true,
        keywordError: undefined
      };
    }
    case getType(searchExamsKeywordActions.success): {
      const { name = '', list, count } = action.payload;
      const nextExamsKeyword = state.examsKeyword;
      nextExamsKeyword[name] = list;
      return {
        ...state,
        isKeywordFetching: false,
        examsKeyword: nextExamsKeyword
      };
    }
    case getType(searchExamsKeywordActions.failure): {
      return {
        ...state,
        isKeywordFetching: false,
        keywordError: action.payload.error
      };
    }

    default: {
      return state;
    }
  }
}
